// Scroll-triggered animations utility
export const initScrollAnimations = () => {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animated');
            }
        });
    }, observerOptions);

    // Observe all elements with animation classes
    const animatedElements = document.querySelectorAll(
        '.animate-on-scroll, .animate-on-scroll-left, .animate-on-scroll-right'
    );

    animatedElements.forEach((el) => {
        observer.observe(el);
    });

    return observer;
};

// Parallax effect for hero section
export const initParallaxEffect = () => {
    const hero = document.querySelector('.hero');
    if (!hero) return;

    const handleScroll = () => {
        const scrolled = window.pageYOffset;
        const rate = scrolled * -0.5;
        hero.style.transform = `translateY(${rate}px)`;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
};

// Typing animation for hero text
export const initTypingAnimation = (element, text, speed = 100) => {
    if (!element) return;

    let i = 0;
    element.textContent = '';

    const typeWriter = () => {
        if (i < text.length) {
            element.textContent += text.charAt(i);
            i++;
            setTimeout(typeWriter, speed);
        }
    };

    typeWriter();
};

// Staggered animation for cards
export const staggerCards = (selector, delay = 100) => {
    const cards = document.querySelectorAll(selector);
    cards.forEach((card, index) => {
        card.style.animationDelay = `${index * delay}ms`;
    });
};

// Smooth scroll to section
export const smoothScrollTo = (targetId) => {
    const target = document.getElementById(targetId);
    if (target) {
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
};

// Initialize all animations
export const initAllAnimations = () => {
    // Initialize scroll animations
    initScrollAnimations();

    // Initialize parallax effect
    initParallaxEffect();

    // Stagger feature cards
    staggerCards('.feature-card', 150);
    staggerCards('.tech-card', 150);
    staggerCards('.use-case', 150);
};
